import {http} from './api';

export const UsersService = {
  get: (userIds, email) => http.get('users',{
      user_ids: userIds,
      email: email
  })};
